import React from "react";
import { FlexGrowProps } from "styled-system";
import { ErrorMessage, Field } from "formik";
import { FormInputErrorMessage } from "../FormInputErrorMessage";
import { FormikDatePicker } from "../FormikDatePicker";

interface Props {
  id: string;
  fieldId: string;
  isDayEnabled: (date: Date) => boolean;
  value: string | undefined;
  label: string;
  displayDateFormat: string;
  placeholder: string;
  minDate?: Date;
  maxDate?: Date;
  openToDate?: Date;
}

export const CommercialNonWorkingDaysDatePicker: React.FC<
  Props & FlexGrowProps
> = ({
  id,
  fieldId,
  isDayEnabled,
  value,
  label,
  displayDateFormat,
  placeholder,
  minDate,
  maxDate,
  openToDate,
}) => {
  return (
    <>
      <Field
        id={id}
        name={fieldId}
        label={label}
        placeholder={placeholder}
        isDayEnabled={isDayEnabled}
        displayDateFormat={displayDateFormat}
        minDate={minDate}
        maxDate={maxDate}
        openToDate={openToDate}
        value={value}
        maxWidth={"265px"}
        component={FormikDatePicker}
      />
      <ErrorMessage
        name={fieldId}
        className="field-error"
        component={FormInputErrorMessage}
      />
    </>
  );
};
